import Styled from "styled-components";
import { Menu, Dropdown } from "antd";

export const GeoButtonWrapper = Styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    
   button {
       background-color: transparent;
       font-family: Montserrat;
       width: ${(props) => (props.desktop ? "136px" : "70%")};
       color: ${(props) => {
			if (props.disabled) {
				return "#8C8C8C";
			}
			return props.borderless ? "#1890FF" : "#D9D9D9";
		}};
        border-radius: 24px;
        height: 28px;
        border: none;
        display: flex;
        justify-content: center;
        align-items:center;
        & svg  {
            width: 32px;
            
        }
        & svg path {
            fill: ${(props) =>
				props.borderless
					? props.disabled
						? "#8C8C8C"
						: "#1890FF"
					: "#000"};
            
        }
        & svg rect {
            stroke: ${(props) =>
				props.borderless
					? props.disabled
						? "#8C8C8C"
						: "#1890FF"
					: "#000"};
        };
        :hover, :active {
            cursor: pointer;
            
            border: none;
            color: ${(props) => !props.disabled && "#1890FF"};
            & svg path {
            fill:${(props) => !props.disabled && "#1890FF"};
            
            
        }
        & svg rect {
            stroke: ${(props) => !props.disabled && "#1890FF"};
        } 
       
   }
`;

export const MenuGeoButtonWrapper = Styled(Menu)`

    .span__label_button {
        color:  #1890FF;
        font-size: 20px;
        margin-right: 12px;

    }
`;
